import React, { Component } from 'react';
import { routerShape } from 'react-router';
import LazyHydrate from 'react-lazy-hydration';
import scrollToComponent from 'react-scroll-to-component-ssr';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import each from 'lodash/each';
import map from 'lodash/map';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import preload from 'api/data-preload';
import seoPreload, { seoDecorator } from 'api/seo';
import Link from 'components/link';
import sensor from 'components/sensor';
import Button from 'components/button';
import Row, { Col } from 'components/row';
import { iconTypes } from 'components/icon';
import DropDown from 'components/drop-down';
import { SeoText } from 'components/layouts';
import Breadcrumbs from 'components/breadcrumbs';
import { OpenGraphImage } from 'components/image';

import linksDomik from 'src-sites/domik/links';
import linksForum from 'src-sites/forum/links';

import DocUserAgreementSite from './docs/doc-user-agreement-site';
import DocPrivacyPolicy from './docs/doc-privacy-policy';
import DocCookieAgreement from './docs/doc-cookie-agreement';
import DocTermsUseMaterials from './docs/doc-terms-use-materials';
import DocRulesPublishingAnnouncements from './docs/doc-rules-publishing-announcements';
import DocRulesPublishingDisplayAd from './docs/doc-rules-publishing-display-ad';

import translates from './terms-i18n.json';

import 'styles/domik/section-terms/_page-terms.scss';

export const sectionId = [
  'polzovatelskoe-soglashenie',
  'politika-konfidentsialnosti',
  'ispolzovanie-cookie',
  'usloviya-ispolzovaniya-materialov',
  'pravila-publikatsii-obyavleniy',
  'pravila-publikatsii-mediynoy-reklamy',
  'p267480'
];
const heightHeader = 20;

const bemClasses = new Bem('pageTerms');

@preload({
  ...seoPreload({ entity: 'pageTerms' }, [])
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@sensor
@I18nHoc(translates)
export default class PageTerms extends Component {
  static propTypes = {
    className: PropTypes.string,
    locality: PropTypes.shape({}),
    params: PropTypes.shape({
      page: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ])
    }),
    listData: PropTypes.shape({}),
    seoData: PropTypes.shape({}),
    router: routerShape
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.getBlockRef = this.getBlockRef.bind(this);
    this.getSections = this.getSections.bind(this);
    this.renderMenuList = this.renderMenuList.bind(this);
    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;
    this.onScroll = this.scrollingBlocks;

    this.state = {
      device: 'phone',
      mounted: false,
      currentSection: sectionId[0],
      scrollOnLoad: false
    };
  }

  componentDidMount() {
    this.onHandleResize(this.sensor.getRuntime());
    this.setState({ mounted: true });
  }

  componentDidUpdate() {
    if (!this.state.scrollOnLoad) this.getBlockRef();
    if (!this.sections) this.getSections();
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;

    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  getBlockRef() {
    const blockRef = get(this, 'props.router.location.hash').replace('#', '');
    if (blockRef && this[blockRef]) scrollToSection.call(this, blockRef);
    this.setState({ scrollOnLoad: true });
  }

  getSections() {
    const sectionIdNew = sectionId.slice(0, 6);
    this.sections = map(sectionIdNew, (section) => {
      const sectionBlock = this[section];

      return {
        id: section,
        sectionBlock
      };
    });
  }

  scrollingBlocks() {
    each(this.sections, (section) => {
      const sectionTop = section.sectionBlock.getBoundingClientRect().top;
      const sectionBottom = section.sectionBlock.getBoundingClientRect().bottom;
      if (
        sectionTop <= heightHeader &&
        sectionBottom >= heightHeader
      ) {
        if (this.state.currentSection !== section.id) {
          return this.setState({ currentSection: section.id });
        }
      }
    });
  }

  renderMenuList() {
    const { i18n } = this;
    const { mounted, device } = this.state;
    const itemList = (
      <ul {...bemClasses('ul', { menu: true, noJs: !mounted })}>
        <li {...bemClasses('li')}>
          {renderLinkTerms.call(this, sectionId[0], i18n('termsUser'), true)}
        </li>
        <li {...bemClasses('li')}>
          {renderLinkTerms.call(this, sectionId[1], i18n('privacyPolicy'), true)}
        </li>
        <li {...bemClasses('li')}>
          {renderLinkTerms.call(this, sectionId[2], i18n('useCookies'), true)}
        </li>
        <li {...bemClasses('li')}>
          {renderLinkTerms.call(this, sectionId[3], i18n('termsUseMaterials'), true)}
        </li>
        <li {...bemClasses('li')}>
          {renderLinkTerms.call(this, sectionId[6], i18n('conceptRulesForum'), true, true)}
        </li>
        <li {...bemClasses('li')}>
          {renderLinkTerms.call(this, sectionId[4], i18n('rulesPublishingAnnouncements'), true)}
        </li>
        <li {...bemClasses('li')}>
          {renderLinkTerms.call(this, sectionId[5], i18n('rulesPublishingDisplayAd'), true)}
        </li>
      </ul>
    );

    if (!mounted) {
      return (
        <>
          <div {...bemClasses('dropdown', 'noJs', 'dropdown')} />
          {itemList}
        </>
      );
    }

    return device === 'desktop' ?
      itemList : (
        <DropDown
          {...bemClasses('dropdown')}
          ref={el => this.ddRef = el}
          modalHeader={i18n('termsUse')}
          inForm
        >
          <Button
            {...bemClasses('btn', 'dropdown')}
            iconSecondType={iconTypes.carretBild}
            label={i18n('all')}
          />
          <div children={itemList} />
        </DropDown>
      );
  }

  render() {
    const { i18n } = this;
    const { className, seoData = {} } = this.props;
    const topic = seoData && seoData.header ? seoData.header : i18n('termsH1');
    const seoText = get(seoData, 'bottomText');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksDomik.sectionDomik,
        builderProps: { title: i18n('breadcrumbsMain') }
      }, {
        name: topic,
        builder: linksDomik.sectionTerms,
        builderProps: { title: topic }
      }
    ];

    return (
      <div {...bemClasses({ extra: className })}>
        <LazyHydrate ssrOnly>
          <OpenGraphImage />
        </LazyHydrate>
        <div {...bemClasses('title')}>
          <div {...bemClasses('text', 'h1')}><h1 children={topic} /></div>
        </div>
        <Row {...bemClasses('row', 'main')} mtColumn mpColumn>
          <Col {...bemClasses('col', 'main')} allFlex allColumn allPr={0}>
            <LazyHydrate whenIdle>
              <DocUserAgreementSite
                blockRef={ref => this[sectionId[0]] = ref}
                blockId={sectionId[0]}
              />
              <DocPrivacyPolicy
                blockRef={ref => this[sectionId[1]] = ref}
                blockId={sectionId[1]}
              />
              <DocCookieAgreement
                blockRef={ref => this[sectionId[2]] = ref}
                blockId={sectionId[2]}
              />
              <DocTermsUseMaterials
                blockRef={ref => this[sectionId[3]] = ref}
                blockId={sectionId[3]}
              />
              <DocRulesPublishingAnnouncements
                blockRef={ref => this[sectionId[4]] = ref}
                blockId={sectionId[4]}
              />
              <DocRulesPublishingDisplayAd
                blockRef={ref => this[sectionId[5]] = ref}
                blockId={sectionId[5]}
              />
            </LazyHydrate>
          </Col>
          <Col {...bemClasses('col', 'aside')} allFlex mdColumn allAuto allPr={0}>
            <aside {...bemClasses('aside')} children={this.renderMenuList()} />
          </Col>
        </Row>
        <SeoText data={seoText} />
        <Breadcrumbs
          {...bemClasses('breadcrumbs')}
          data={dataBreadcrumbs}
        />
      </div>
    );
  }
}

export function scrollToSection(blockRef) {
  // const heightHeader = toNumber(this.sensor.getVariable('heightHeaderPx'));

  if (this.state.device !== 'desktop') this.ddRef.getInstance().close();

  scrollToComponent(this[blockRef], {
    align: 'top',
    ease: 'linear',
    duration: 300,
    offset: -(heightHeader)
  });
}

export function renderLinkTerms(id, text, isMenu = false, toForum = false) {
  const currentSection = get(this, 'state.currentSection');
  let linkProps = {};

  if (toForum) {
    linkProps = {
      builder: linksForum.sectionTopic,
      builderProps: {
        topicUrl: '/domik-rules-t19531.html',
        topic_title: text,
        hash: `#${id}`
      },
      noRedirector: true
    };
  }
  if (!toForum) {
    linkProps = {
      onClick: () => scrollToSection.call(this, id),
      href: `#${id}`,
      title: text,
      external: true
    };
  }

  return (
    <Link
      {...bemClasses('link', { menu: isMenu, active: id === currentSection })}
      {...linkProps}
    >
      <span {...bemClasses('linkContent')}>
        <span {...bemClasses('text', 'link menu')} children={text} />
      </span>
    </Link>
  );
}
